import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import enterprise_img from '../../../../assets/image/smeResearchTalentSupport_img.jpg';
import SubTab from '../SubTab/SubTab';

const SMEResearchTalentSupport = () => {
  const category = 'smeResearchTalentSupport';
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();
  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };
  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate: cate } });
  };
  const movePage = (path) => {
    navigate(path);
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}사업분야{' > '}인재 양성 사업
            </div>
            <div className="banner_main_text">인재 양성 사업</div>
          </div>
        </div>
        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box business_field" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">인재양성사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  산학융합지구조성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/chungnamInnovationProject')}>
                  기업지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/localIndustryTalentDevelopment')}>
                  인재양성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/YouthEmploymentSupport')}>
                  창업육성사업
                </div>
              </div>
            </div>
            <div className="navi_box human" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">중소기업 연구인력 현장맞춤형 양성지원사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/business/localIndustryTalentDevelopment')}>
                  지역산업맞춤형 인력양성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/koreanQuickStartProgram')}>
                  한국형 퀵스타트프로그램 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/smeResearchTalentSupport')}>
                  중소기업 연구인력 현장맞춤형 양성지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/FutureWorkExperience1')}>
                  미래내일경험(사전직무교육기관)
                </div>
                <div className="select_row" onClick={() => movePage('/business/FutureWorkExperience2')}>
                  미래내일경험(인턴형)
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sub_main_area temporary">
          <SubTab category={category} />
          {/* 🔹 공통으로 돌려 쓸 카드 헤더(리디자인 영역) */}
          <div className="business-hero">
            <div className="business-hero-inner">
              <p className="business-hero-tag">SME Research Talent Field Training Support</p>
              <h2 className="business-hero-title">중소기업 연구인력 현장맞춤형 양성지원사업</h2>
              <p className="business-hero-period">사업기간 : (계속사업) 2025.3~2026.2</p>
            </div>
          </div>
          <div className="sub_main_back">
            <div className="vision_container">
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">사업내용</div>
              </div>
              <div className="propulsion_box">
                <div className="sme-img2"></div>
              </div>
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">추진체계</div>
              </div>
              <div className="propulsion_box">
                <div className="sme-img3"></div>
              </div>
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">사업 목표 및 최종 성과</div>
              </div>
              <div className="propulsion_box">
                <div className="sme-img4"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SMEResearchTalentSupport;
